import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import Swal from 'sweetalert2';
import {URI} from '../../Conexiones/Conexion';
import { getToken } from '../../Conexiones/Conexion';

const AgregarAsisOfi = () => {
    const navigate = useNavigate()
    const [nombre, setNombre] = useState('');
    const [asistencia, setAsistencia] = useState();
    const [fecha, setFecha] = useState();
    const [observacion, setObservacion] = useState('');
    const [personal, setPersonal] = useState([])

    useEffect( ()=>{
        const getAllEmpleados = async () =>{
            const res = await axios.get(URI+'listaOfi',{
                headers: {
                    'Authorization': `Bearer ${getToken()}`
                },
                }).catch(
                    err =>{
                        if(err.response.data === "Token Inválido" | err.response.data === "Token requerido"){
                            navigate('/')
                        }
                    }
                )
            setPersonal(res.data)
        }
        getAllEmpleados()
    }, [navigate])

    const store = async (e) =>{
        e.preventDefault()
        const idEmp = parseInt(nombre)
        const asis = parseFloat(asistencia)
        if(nombre.trim().length === 0){
            Swal.fire({
                title: 'CAMPOS VACIOS',
                icon: 'warning',
                iconColor:'#1e2c4f',
                color: '#1e2c4f',
                text: 'EL CAMPO NOMBRE ESTA VACÍO',
                confirmButtonColor: '#1e2c4f',
                confirmButtonText: 'ACEPTAR',
            })
        }else{
            await axios.post(URI+'asisAtrasadaOfi', {idEmpleado:idEmp, asistencia:asis, fecha:fecha, observacion:observacion}).then(
                res => {
                    if(res.data.message === "connect ECONNREFUSED 127.0.0.1:3306"){
                        Swal.fire(
                            'Falla en el servidor...',
                            'Intente más tarde',
                            'question'
                        )
                    }else{
                        if(res.data.message==="SE GUARDÓ ASISTENCIA CORRECTAMENTE"){
                            Swal.fire({
                                icon: 'success',
                                title: res.data.message,
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    window.location.reload();
                                } 
                            })
                        }else{
                            Swal.fire({
                                title: '¡ERROR!',
                                text: res.data.message,                 
                                icon: 'error',
                                confirmButtonColor: 'red',
                                allowOutsideClick: false,
                                confirmButtonText: 'ACEPTAR'
                            })
                        }

                    }
                }
            ).catch(
                err => {
                    if(err.message === "Network Error"){
                        Swal.fire(
                            'Falla en el servidor...',
                            'Intente más tarde',
                            'question'
                        )
                    }else{
                        Swal.fire(
                            'Falla en el servidor...',
                            err.message,
                            'question'
                        )
                    }
                }
            )
        }
    }

    return (
        <div>            
        <div className="modal fade" id="modal-agregar-asistencia" data-bs-backdrop="static" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog ">
                <div className="modal-content">
                    <div className="modal-header btncolor" >
                        <h5 className="modal-title" id="exampleModalLabel">AGREGAR ASISTENCIA</h5>
                        <button type="button" className="btn-close bg-white" data-bs-dismiss="modal" aria-label="Close" ></button>
                    </div>
                    <form onSubmit={store} >
                    <div className="divO">
                        <label className="obligatorio">Obligatorio *</label>  
                    </div>
                    <div className="modal-body" style={{textAlign:'left', marginTop:'-20px'}}>
                        <div className="mb-3">
                            <label htmlFor="exampleFormControlInput1" className="form-label">NOMBRE <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                            <select className="form-control" required 
                                onChange={e => setNombre(e.target.value) }   >
                                <option >--Seleccione una opción--</option>
                                {personal.map(p => {
                                    return(
                                        <option key={p.idEmpleado} value={p.idEmpleado}>{p.nombreEmp+' '+p.apellidoPaternoEmp+' '+p.apellidoMaternoEmp}</option>
                                    )
                                })
                                }                                
                            </select>
                        </div>
                        <div className="mb-3">
                            <label htmlFor="exampleFormControlInput1" className="form-label">FECHA <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                            <input type="date" className="form-control"  id="exampleFormControlInput1" required 
                            onChange={e => setFecha(e.target.value) }/>
                        </div>
                        <div className="mb-3">
                            <label htmlFor="exampleFormControlInput1" className="form-label">ASISTENCIA <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                            <div onChange={e => setAsistencia(e.target.value)}>
                                <div className="form-check form-check-inline" >
                                    <input className="form-check-input" type="radio" value="1" name="asistencia" id="asistencia1"  required/>
                                    <label className="form-check-label" htmlFor="asistencia1">
                                        ASISTIÓ
                                    </label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input className="form-check-input" type="radio" value="0" name="asistencia" id="asistencia2" />
                                    <label className="form-check-label" htmlFor="asistencia2">
                                        NO ASISTIÓ
                                    </label>
                                </div>                             
                            </div>
                        </div>
                        <div className="mb-3">
                            <label htmlFor="exampleFormControlInput1" className="form-label">OBSERVACION </label>
                            <input type="text" className="form-control"  id="exampleFormControlInput1"
                            onChange={e => setObservacion(e.target.value) }/>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">CANCELAR</button>                                               
                        <button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</button>                                                
                    </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    );
};

export default AgregarAsisOfi;